import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import EfLink from '@elem/ui/ef-link';
import gtm from '@/utils/gtm';

export default function FixTab() {
    const { t } = useLang('bkw');
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('tab_1'), id: '#bkw-C', key: 0 },
        { text: t('tab_2'), id: '#bkw-G', key: 1 },
        { text: t('tab_3'), id: '#bkw-J', key: 2 },
        { text: t('tab_4'), id: '#bkw-N', key: 3 },
        { text: t('tab_5'), id: '#bkw-O', key: 4 },
    ];
    const handleClickTab = (k: number) => {
        setActiveTab(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_navigation',
            navigation_name: tabs[k].text,
            position: 'Top',
        });
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth - 105 - 48) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeFunc = () => {
                const target = document.querySelector('.bkw-fix-tab .tabs-box') as HTMLUListElement;
                target.style.transition = 'left .4s ease';
                if (target.offsetWidth > window.innerWidth - 105 - 48 && activeTab >= 3) {
                    target.style.left = `${window.innerWidth - 105 - 48 - target.offsetWidth}px`;
                } else {
                    target.style.left = `${0}px`;
                }
                setTimeout(() => {
                    target.style.transition = 'none';
                }, 400);
            };
            resizeFunc();
            // window.addEventListener('resize', resizeFunc);
            // return () => window.removeEventListener('resize', resizeFunc);
        }
    }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string, k: number) => {
            const target = document.querySelector(id) as HTMLDivElement;
            if (target) {
                AniContainer.create({
                    triggerElement: id,
                    triggerHook: 1,
                    offset: '50%',
                    duration: target?.offsetHeight,
                    onEnter: () => setActiveTab(k),
                });
            }
        };

        const ids: string[] = ['#bkw-C', '#bkw-G', '#bkw-J', '#bkw-N', '#bkw-O'];
        ids.forEach((id: string, k: number) => scrollFunc(id, k));

        // AniContainer.create({
        //     triggerElement: '#bkw-R',
        //     triggerHook: 1,
        //     offset: '50%',
        //     onEnter: () => setActiveTab(5),
        // });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`bkw-fix-tab ${css['bkw-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
                <div className="tabs-btn-box">
                    <EfLink
                        className="tabs-btn"
                        href={'#bkw-E'}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_navigation',
                            navigation_name: t('tab_btn'),
                            position: 'Top',
                        }}
                    >
                        {t('tab_btn')}
                    </EfLink>
                </div>
            </div>
        </div>
    );
}
